import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/campusFacilitiesPageImages/hostelLifePageImages/hostel.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/campusFacilitiesPageImages/hostelLifePageImages/hostelMobile.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CampusFacilitiesPageComponents/HostelLife/AmenitiesSection/AmenitiesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/FooterCard/FooterCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/VideoPlayer/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/StickyBottomBar/StickyBottomBar.tsx");
